import Link from "next/link";
import PopularGames from "../components/PopularGames";
export default function GameCommonDis() {
  return (
    <div className="dis-container">
      <div className="thumb-dis">
        <div className="dis">
          <h2 className="contant name">
            Play free Cute games at bestgamespot.com
          </h2>
          {/* <PopularGames /> */}
        </div>
      </div>
    </div>
  );
}
